import { Entity } from '@toggle/toggle';
import React from 'react';

import { ScheduleDemoBanner } from '~/views/stream/components/schedule-demo-banner/ScheduleDemoBanner';
import { CompanyCatalystWidget } from '~/widgets/catalyst-insights-drawer/company-catalyst-widget/CompanyCatalystWidget';
import { EarningsInsightWidget } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/EarningsInsightWidget';
import { UpgradeToUnlock } from '~/widgets/overview/components/upgrade-to-unlock/UpgradeToUnlock';

import { ScenarioInsightWidget } from '../insight-widget/components/insight-drawer/components/insights-drawer-content/ScenarioInsightWidget';
import { ActiveFlow } from './InsightDrawerShell';
import styles from './InsightDrawerShell.module.scss';

export const renderDrawerChildren = ({
  activeFlow,
  insightId,
  isBasicOrLightUser,
  contentWrapperRef,
  expandCitations,
  entity,
}: {
  activeFlow?: ActiveFlow;
  insightId: string;
  isBasicOrLightUser: boolean;
  contentWrapperRef: React.RefObject<HTMLDivElement | null>;
  expandCitations: boolean;
  entity?: Entity;
}) => {
  if (activeFlow === 'insights' && insightId) {
    return (
      <ScenarioInsightWidget
        insightId={insightId}
        contentWrapperRef={contentWrapperRef}
      />
    );
  }

  if (activeFlow === 'earnings' && !isBasicOrLightUser) {
    return (
      <div ref={contentWrapperRef}>
        <EarningsInsightWidget
          expandCitations={expandCitations}
          entity={entity}
        />
      </div>
    );
  }

  if (activeFlow === 'catalyst' && insightId && !isBasicOrLightUser) {
    return (
      <div ref={contentWrapperRef} className={styles.shellContentWrapper}>
        <CompanyCatalystWidget
          insightId={insightId}
          expandCitations={expandCitations}
        />
        <ScheduleDemoBanner />
      </div>
    );
  }

  return <UpgradeToUnlock />;
};
